import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return (
    <>
        {/* {sidebarOpen && <Sidebar />}

      <div className={`page-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
      
      </div> */}
        <Outlet />
    </>
  );
}